import initializeSdk from './sdk/umdLoader';
import { getEnv } from './woocommerce';

export const createSdk = async ( onSdkError, onComponentListChange ) => {
	const { websdkStyles: styles } = window.PayoneerData;

	const env = getEnv();

	return await initializeSdk( {
		env,
		onBeforeError: onSdkError,
		onComponentListChange,
		preload: [ 'cards' ],
		styles,
	} );
};
